module.exports = __webpack_public_path__ + "601e0a07d92406df161d06f6d40b893c.png";